<template>
	<div :id="$route.params.hotelId ? 'full_page' : ''" class="menus-page" :class="($route.name == 'public-menu') ? 'p-5': ''">
        <div class="logo" v-if="$route.name == 'public-menu'">
            <img :src="require('@/assets/images/logo/Logotipo_Verde.png')" alt="logo" class="w-10 mr-4 align-middle">
            <span style="color: #476061" class="logo-text -my-1 align-middle"><em>My</em> Vila Galé</span>
        </div>

        <div class="flex my-5">
            <div class="w-4/5">
                <h1>{{ $t($route.meta.page_title_i18n) }}</h1>
            </div>

            <div v-if="$route.params.hotelId && $route.name === 'public-menu'" class="w-1/5">
                <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer float-right">
                    <span class="cursor-pointer flex i18n-locale"><img class="w-6 h-6" :src="require(`@/assets/images/flags/${$i18n.locale}.png`)" :alt="$i18n.locale" /><span class="hidden sm:block ml-2"></span></span>
                    <vs-dropdown-menu class="w-50 i18n-dropdown">
                        <vs-dropdown-item @click="updateLocale('en')"><img class="w-6 h-6 mr-1" src="@/assets/images/flags/en.png" alt="en" /> &nbsp;{{ $t('en') }}</vs-dropdown-item>
                        <vs-dropdown-item @click="updateLocale('pt')"><img class="w-6 h-6 mr-1" src="@/assets/images/flags/pt.png" alt="pt" /> &nbsp;{{ $t('pt') }}</vs-dropdown-item>
                        <vs-dropdown-item @click="updateLocale('br')"><img class="w-6 h-6 mr-1" src="@/assets/images/flags/br.png" alt="br" /> &nbsp;{{ $t('br') }}</vs-dropdown-item>
                        <vs-dropdown-item @click="updateLocale('de')"><img class="w-6 h-6 mr-1" src="@/assets/images/flags/de.png" alt="de" /> &nbsp;{{ $t('de') }}</vs-dropdown-item>
                        <vs-dropdown-item @click="updateLocale('fr')"><img class="w-6 h-6 mr-1" src="@/assets/images/flags/fr.png" alt="fr" /> &nbsp;{{ $t('fr') }}</vs-dropdown-item>
                        <vs-dropdown-item @click="updateLocale('es')"><img class="w-6 h-6 mr-1" src="@/assets/images/flags/es.png" alt="es" /> &nbsp;{{ $t('es') }}</vs-dropdown-item>
                    </vs-dropdown-menu>
                </vs-dropdown>
            </div>
        </div>
        <div class="mb-5">
            <hotelDropdown v-bind:append_to_body="false" v-bind:current_stay="hotel_id" v-on:onChangeHotel="onChangeHotel"></hotelDropdown>
        </div>

        <div v-if="menus.length > 0 && !show_menu" class="vx-row">
            <div class="vx-col w-full mb-base" v-if="filtro_options.length > 1">
                <small class="block">{{$t('Filtro')}}</small>
                <ul class="radios">
                    <li class="mr-5 mb-2">
                        <vs-radio v-model="filtro" vs-name="categoria" vs-value="0">{{$t('Todas')}}</vs-radio>
                    </li>
                    <li v-for="(f, index) in filtro_options" :key="index" class="mr-5 mb-2">
                        <vs-radio v-model="filtro" vs-name="categoria" :vs-value="f.categoria_id">
                            {{ f['categoria_' +$i18n.locale] }}
                        </vs-radio>
                    </li>
                </ul>
            </div>
            <div class="vx-col w-full sm:w-1/2 lg:w-1/3 mb-base" v-for="(item, index) in menus_translated" :key="index">
                <vx-card>
                    <div slot="no-body">
                        <img v-if="item.image_path !== null" :src="item.image_path" alt="content-img" class="responsive card-img-top">
                        <img v-else :src="require('@/assets/images/default_menu.jpg')" alt="content-img" class="responsive card-img-top">
                    </div>
                    <div>
                        <h5>{{ item.name }}</h5>
                        <div class="flex justify-between flex-wrap">
                            <button type="button" class="vs-component vs-button w-full mt-4 vs-button-primary vs-button-filled vs-button-gradient" name="button" style="background: rgba(0, 0, 0, 0) linear-gradient(30deg, rgb(115, 103, 240) 0%, rgb(206, 159, 252) 100%) repeat scroll 0% 0%;" v-on:click="goToMenu(item)">
                                <span class="vs-button-text vs-button--text">{{ $t('open') }}</span>
                                <span class="vs-button-linex"></span>
                            </button>
                        </div>
                    </div>
                </vx-card>
            </div>
        </div>
        <div v-if="hotel_id != '' && menus_translated.length == 0 && !show_menu">
            <vx-card>
                <p align="center">{{ $t('noMenus') }}</p>
            </vx-card>
        </div>

        <div v-if="show_menu">
            <div>
                <vs-button @click="sidebar_active=!sidebar_active" color="primary" type="filled" class="btn_side_bar" icon-pack="feather" icon="icon-menu"></vs-button>
                <vs-sidebar hidden-background position-right v-model="sidebar_active" click-not-close class="items-no-padding side_bar_menu" parent=".menus-page">

                    <div class="customizer-header mt-6 flex items-center justify-between px-4" v-on:click="scrollToRef()">
                        <div>
                            <h4 class="cursor-pointer">{{$t('Chapters')}}</h4>
                        </div>
                        <feather-icon icon="XIcon" @click.stop="sidebar_active = false" class="cursor-pointer"></feather-icon>
                    </div>
                    
                    <vs-divider class="mb-0"></vs-divider>
                    <VuePerfectScrollbar class="scroll-area pt-4 pb-6" :settings="{maxScrollbarLength: 60, wheelSpeed: .60}">

                        <div v-if="selected_menu != ''" v-for="(c, index) in activeItems(convertToBool(selected_menu.capitulos))" :key="index" v-on:click="scrollToRef(c.id)" class="px-4">

                            <div class="cursor-pointer">
                                <div class="mt-4 flex justify-between">
                                    <h5 class="cursor-pointer">{{c.name}}</h5>
                                </div>
                            </div>

                            <vs-divider class="mb-0"></vs-divider>

                        </div>

                    </VuePerfectScrollbar>

                </vs-sidebar>
            </div>
            <vs-button class="float-right" color="primary" v-on:click="goBackToMenus()">{{ $t('returnButton') }}</vs-button>
            <vs-button class="float-right mr-2" color="warning" type="filled" icon-pack="feather" icon="icon-printer" v-on:click="createPdf()" v-if="$user && $user.is_staff"></vs-button>
            <h2 class="my-5">{{ selected_menu.name }}</h2>

            <div>

                <div v-if="type == 'Menu' && price !== null">
                    <div class="flex justify-between items-center mb-3">
                        <span style="background:rgba(var(--vs-primary),.15);" class="p-3 inline-flex rounded-full feather-icon select-none relative text-warning">
                            <h4 style="color: rgba(var(--vs-primary),1);">{{ price + ' ' + currency }}</h4>
                        </span>
                    </div>
                </div>
                <div v-else class="pt-2"></div>
                <div v-if="selected_menu.description !== null">
                    <vs-collapse style="background-color: #ffffff;" class="bg-white desc-collapse">
                        <vs-collapse-item>
                            <div slot="header" class="p-0">
                                <p class="m-0"><b>{{$t('Saber_mais')}}...</b></p>
                            </div>
                            <p v-html="line_feed_to_br(selected_menu.description)"></p>
                        </vs-collapse-item>
                    </vs-collapse>
                </div>

                <vx-card class="w-full mt-4 mb-3"
                :title="c.name" v-for="(c, index) in activeItems(convertToBool(selected_menu.capitulos))" :key="index">

                    <div :ref="'c_' +c.id">
                        <p align="center" class="my-5" v-if="activeItems(convertToBool(c.sub_capitulos)) == 0">
                            {{ $t('noItemsAvailable')}}
                        </p>

                        <vx-card v-else class="mb-3" :key="indextr" v-for="(item, indextr) in activeItems(convertToBool(c.sub_capitulos))">
                            <div class="productItem flex flex-wrap">
                                <div class="w-full">
                                    <div class="float-left">
                                        <strong>
                                            {{ item.nome }}
                                        </strong>
                                        <p v-html="line_feed_to_br(item.descricao)"></p>
                                    </div>
                                </div>
                                <div class="w-full">
                                    <div class="float-right ml-2" v-if="item.logotipo.length > 0" v-for="(logo, indexlogo) in item.logotipo" :key="indexlogo">
                                        <div class="con-vs-avatar mx-auto block 40px m-0 logoIcon">
                                            <div class="con-img vs-avatar--con-img">
                                                <img :alt="logo.name" :src="logo.image_path">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="flex flex-wrap">
                                <div class="w-full" v-if="item.preco > 0">
                                    <vs-divider color="primary" />
                                    <div class="flex flex-wrap">
                                        <div class="w-full">
                                            <div class="float-right">
                                                <div class="flex mb-3">
                                                    <span class="pt-1 w-36 text-right pr-4">
                                                        {{ parseFloat(item.preco).toFixed(2) + ' ' + currency }}
                                                    </span>
                                                    <vs-button v-if="item.room_service == 1 && item.sub_capitulo_medidas.length == 0 && user !== null && user.hotel.hotel_id == hotel_id" v-show="!$route.params.hotelId" color="primary" size="small" type="filled" icon-pack="feather" icon="icon-plus" v-on:click="order(item.id, item.nome, item.descricao, item.preco, currency, 0, '')"></vs-button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="w-full" v-if="activeItems(convertToBool(item.sub_capitulo_medidas)).length > 0">
                                    <vs-divider color="primary" />
                                    <div class="flex flex-wrap">
                                        <div class="w-full">
                                            <div class="float-right">
                                                <div class="flex mb-3" v-for="(m, index) in activeItems(convertToBool(item.sub_capitulo_medidas))" :key="index">
                                                    <span class="pt-1 w-24 text-right pr-4">
                                                        {{ m.volume + ' ' + m.medida }}
                                                    </span>
                                                    <span v-if="m.preco !== null" class="pt-1 w-36 text-right pr-4">
                                                        {{ m.preco ? parseFloat(m.preco).toFixed(2) + ' ' + currency : '' }}
                                                    </span>
                                                    <vs-button v-show="!$route.params.hotelId" v-if="m.room_service == 1 && user !== null && user.hotel.hotel_id == hotel_id" color="primary" size="small" type="filled" icon-pack="feather" icon="icon-plus" v-on:click="order(item.id, item.nome, item.descricao, m.preco, currency, m.id, m.volume + ' ' + m.medida)"></vs-button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="w-full text-right" v-if="item.cod_menu_link !== null &&
                                                                    item.menu !== null &&
                                                                    item.menu.idiomas.length !== 0">
                                    <vs-divider color="primary" />
                                    <router-link :to="{name: $route.name, params: {hotelId: hotel_id}, query: {id: item.cod_menu_link, return: $route.query.id}}"><button type="button" name="button" class="vs-component vs-button vs-button-primary vs-button-filled small">
                                        <span class="vs-button-backgroundx vs-button--background" style="opacity: 1; left: 20px; top: 20px; width: 0px; height: 0px; transition: width 0.3s ease 0s, height 0.3s ease 0s, opacity 0.3s ease 0s;"></span>
                                        <span class="vs-button-text vs-button--text">{{$t('Saber_mais')}}...</span>
                                        <span class="vs-button-linex" style="top: auto; bottom: -2px; left: 50%; transform: translate(-50%);"></span>
                                    </button></router-link>
                                </div>
                            </div>
                        </vx-card>
                    </div>
                </vx-card>


                <!-- <vs-tabs v-if="selected_menu != ''">
                    <vs-tab v-for="(c, index) in activeItems(convertToBool(selected_menu.capitulos))" :key="index" :label="c.name">

                        <p align="center" class="my-5" v-if="activeItems(convertToBool(c.sub_capitulos)) == 0">
                            {{ $t('noItemsAvailable')}}
                        </p>

                        <vx-card v-else class="my-3" :key="indextr" v-for="(item, indextr) in activeItems(convertToBool(c.sub_capitulos))">
                            <div class="w-full">
                                <strong>
                                    {{ item.nome }}
                                </strong>
                                <p>
                                    {{ item.descricao }}
                                </p>
                            </div>
                            
                            <div class="flex flex-wrap">
                                <div class="w-full" v-if="item.preco > 0">
                                    <vs-divider color="primary" />
                                        <div class="flex flex-wrap">
                                            <div class="w-full">
                                                <div class="float-right">
                                                    <div class="flex mb-3">
                                                        <span class="pt-1 w-36 text-right pr-4">
                                                            {{ parseFloat(item.preco).toFixed(2) + ' ' + currency }}
                                                        </span>
                                                        <vs-button v-if="item.room_service == 1 && item.sub_capitulo_medidas.length == 0 && user !== null && user.hotel.hotel_id == hotel_id" v-show="!$route.params.hotelId" color="primary" size="small" type="filled" icon-pack="feather" icon="icon-plus" v-on:click="order(item.id, item.nome, item.descricao, item.preco, currency, 0, '')"></vs-button>
                                                    </div>
                                                </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="w-full" v-if="activeItems(convertToBool(item.sub_capitulo_medidas)).length > 0">
                                    <vs-divider color="primary" />
                                    <div class="flex flex-wrap">
                                        <div class="w-full">
                                            <div class="float-right">
                                                <div class="flex mb-3" v-for="(m, index) in activeItems(convertToBool(item.sub_capitulo_medidas))" :key="index">
                                                    <span class="pt-1 w-24 text-right pr-4">
                                                        {{ m.volume + ' ' + m.medida }}
                                                    </span>
                                                    <span class="pt-1 w-36 text-right pr-4">
                                                        {{ m.preco ? parseFloat(m.preco).toFixed(2) + ' ' + currency : '' }}
                                                    </span>
                                                    <vs-button v-show="!$route.params.hotelId" v-if="m.room_service == 1 && user !== null && user.hotel.hotel_id == hotel_id" color="primary" size="small" type="filled" icon-pack="feather" icon="icon-plus" v-on:click="order(item.id, item.nome, item.descricao, m.preco, currency, m.id, m.volume + ' ' + m.medida)"></vs-button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </vx-card>
                    </vs-tab>
                </vs-tabs> -->

                <div class="w-full" v-if="show_veg">
                    <div class="flex items-center">
                        <img class="con-vs-avatar mr-2 ml-0 legendaLogo" src="https://vgcontent.s3-eu-west-1.amazonaws.com/myvilagale/menu-logotipo/Veg.jpg">
                        <small>Vegetariano</small>
                    </div>
                </div>
                <div class="w-full" v-if="show_sg">
                    <div class="flex items-center">
                        <img class="con-vs-avatar mr-2 ml-0 legendaLogo" src="https://vgcontent.s3-eu-west-1.amazonaws.com/myvilagale/menu-logotipo/SG.jpg">
                        <small>Sem Glúten</small>
                    </div>
                </div>
                <div class="w-full" v-if="show_vg">
                    <div class="flex items-center">
                        <img class="con-vs-avatar mr-2 ml-0 legendaLogo" src="https://vgcontent.s3-eu-west-1.amazonaws.com/myvilagale/menu-logotipo/Icon_vegan.png">
                        <small>Vegan</small>
                    </div>
                </div>
                <div class="w-full" v-if="show_dt">
                    <div class="flex items-center">
                        <img class="con-vs-avatar mr-2 ml-0 legendaLogo" src="https://vgcontent.s3-eu-west-1.amazonaws.com/myvilagale/menu-logotipo/Icon_detox.png">
                        <small>Detox</small>
                    </div>
                </div>
                <div class="w-full" v-if="show_lat">
                    <div class="flex items-center">
                        <img class="con-vs-avatar mr-2 ml-0 legendaLogo" src="https://vgcontent.s3-eu-west-1.amazonaws.com/myvilagale/menu-logotipo/Icon_lacticinios.png">
                        <small>Laticínios</small>
                    </div>
                </div>
                <div class="w-full" v-if="show_ec">
                    <div class="flex items-center">
                        <img class="con-vs-avatar mr-2 ml-0 legendaLogo" src="https://vgcontent.s3-eu-west-1.amazonaws.com/myvilagale/menu-logotipo/Icon_especialidade_do_chef.png">
                        <small>Especialidade do Chef</small>
                    </div>
                </div>

                <div>
                    <p v-html="line_feed_to_br(selected_menu.information)"></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
//load hotel dropdown from components
import HotelDropdown from '@/views/components/HotelDropdown.vue';
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
    data() {
        return {
            menus: [],
            idiomas: [],
            current_stay_hotel: '',
            selected_menu: '',
            show_menu: false,
            sidebar_active: false,
            currency: '',
            type: '',
            c_offsets: {},
            popupActive: false,
            current_order: {},
            cart: [],
            user: JSON.parse(window.localStorage.getItem('userSession')),
            hotel_id: '',
            filtro: 0,
            filtro_options: [],
            show_sg: false,
            show_veg: false,
            show_vg: false,
            show_dt: false,
            show_lat: false,
            show_ec: false,
        }
    },
    watch : {
        selected_menu: function(new_val, old_val) {
            if(new_val != '') {
                let that = this;
                this.$nextTick(function () {
                    for(let c of new_val.capitulos) {
                        that.c_offsets['c_' +c.id] = window.pageYOffset + that.$refs['c_' +c.id][0].getBoundingClientRect().top-170;
                    }
                });
            }else {
                this.c_offsets = {};
            }
        },
        '$i18n.locale': function(newLang, oldLang) {
            let params = {hotelId: this.hotel_id};
            if(this.$route.name === 'public-menu') {
                params.lang = newLang;
            }
            else if(typeof this.$route.query.id !== 'undefined') {
                this.seeMenu(this.selected_menu, true);
                return;
            }
            else {
                this.getMenus(this.$route.params.hotelId);
            }
            this.$router.push({name: this.$route.name, params: params, query: this.$route.query});
        }
    },
    created: function () {
        if(localStorage.getItem('current_stay')) {
            let stay = JSON.parse(localStorage.getItem('current_stay'));
            this.current_stay_hotel = stay.hvg_nome;
        }
    },
    computed: {
        menus_translated: function() {
            let mt = [], trans_tmp, ids_cats = this.filtro_options.map((item, idx) => item.categoria_id);
            for(let m of this.menus) {
                if(m.visibility == 1) {
                    if(this.filtro == 0 || m.categoria_id == this.filtro){
                        if(['Directório', 'Marcação'].indexOf(m.type) === -1) {
                            if(ids_cats.indexOf(m.categoria_id) !== -1 || (m.categoria_id === null && this.$route.meta.with_id_cat_null)) {
                                trans_tmp = m.idiomas.find((i, idx) => i.language === this.$i18n.locale.toUpperCase());
                                if(typeof trans_tmp !== 'undefined' && trans_tmp.visibility == 1) {
                                    trans_tmp.type = m.type;
                                    trans_tmp.image_path = m.image_path;
                                    trans_tmp.price = m.price;
                                    mt.push(trans_tmp);
                                }
                            }
                        }
                    }
                }
            }
            return mt;
        },
    },
    methods: {
        room_service(items) {
            return items.filter(x => x.room_service == 1);
        },
        line_feed_to_br: function(str) {
            if(str === null)
                return str;
            return str.split("\n").join("<br />");
        },
        onChangeHotel(newHotel) {
            this.goBackToMenus();
            this.hotel_id = newHotel;
            this.idiomas = [];
            let params = {hotelId: newHotel};
            if(this.$route.name === 'public-menu') {
                params.lang = this.$route.params.lang;
            }

            this.$router.push({name: this.$route.name, params: params});
        },
        scrollToRef: function(id) {
            this.sidebar_active =  false;
            let scroll_to = this.c_offsets['c_' +id];
            if(typeof id === 'undefined') {
                scroll_to = 0;
            }
            this.scrollPageTo(scroll_to, 400);
        },
        scrollPageTo: function(to, duration=500) {
          const easeInOutQuad = function (t, b, c, d) {
            t /= d/2;
            if (t < 1) return c/2*t*t + b;
            t--;
            return -c/2 * (t*(t-2) - 1) + b;
          };

          return new Promise((resolve, reject) => {
            const element = document.scrollingElement;

            if (typeof to === 'string') {
              to = document.querySelector(to) || reject();
            }
            if (typeof to !== 'number') {
              to = to.getBoundingClientRect().top + element.scrollTop;
            }

            let start = element.scrollTop,
                change = to - start,
                currentTime = 0,
                increment = 20;

            const animateScroll = function() {
                currentTime += increment;
                let val = easeInOutQuad(currentTime, start, change, duration);
                element.scrollTop = val;
                if(currentTime < duration) {
                    setTimeout(animateScroll, increment);
                } else {
                  resolve();
                }
            };
            animateScroll();
          });
        },
        goToMenu(menu){
            window.scrollTo(0, 0);
            if(!isNaN(this.$route.query.return)){
                this.$router.replace({query: {id: menu.menu_id, return: that.$route.query.return}});
            }else{
                this.$router.replace({query: {id: menu.menu_id}});
            }
        },
        seeMenu(menu, force) {
            if(typeof menu === 'undefined' || (!force && this.selected_menu.menu_id == menu.menu_id)) {
                return;
            }
            let that = this;
            that.$vs.loading();

            this.$api({
                method: 'get',
                url: '/myvilagale/hotel/get_menu_data?token=' +process.env.VUE_APP_TOKEN,
                params: {
                    // hotelId: this.user.hotel.hotel_id,
                    id: menu.menu_id,
                    hotel_id: this.hotel_id,
                    lang: this.$i18n.locale,
                },
            })
            .then(function (res) {
                if(typeof res.data.capitulos === 'undefined' || res.data.capitulos.length == 0) {
                    that.$vs.notify({
                        text: that.$t('noChapter'),
                        color:'danger',
                        position:'bottom-right',
                        iconPack: 'feather',
                        icon:'icon-alert-triangle'
                    });
                    that.$vs.loading.close();
                    that.goBackToMenus();
                    return false;
                }
                that.selected_menu = res.data;
                that.show_menu = true;
                that.type = that.selected_menu.menu.type;
                that.price = that.selected_menu.menu.price;

                if(res.data.menu.currency == 'Euro'){
                    that.currency = 'EUR';
                } else if(res.data.menu.currency == 'Real'){ 
                    that.currency = 'BRL';
                } else {
                    that.currency = 'USD';
                }

                window.scrollTo(0, 0);
                if(!isNaN(that.$route.query.return)){
                    that.$router.replace({query: {id: menu.menu_id, return: that.$route.query.return}});
                }else{
                    that.$router.replace({query: {id: menu.menu_id}});
                }
                that.checkForSubtitle(that.selected_menu.capitulos);
            })
        },
        checkForSubtitle(capitulos){
            this.show_sg = false;
            this.show_veg = false;
            for (let x = 0; x < capitulos.length; x++) {
                if(capitulos[x].sub_capitulos.length > 0){
                    let sub_capitulos = capitulos[x].sub_capitulos;
                    for (let i = 0; i < sub_capitulos.length; i++) {
                        if(sub_capitulos[i].logotipo.length > 0){
                            let logos = sub_capitulos[i].logotipo;
                            for (let j = 0; j < logos.length; j++) {
                                if(logos[j].menu_logotipo_id == 10){
                                    this.show_sg = true;
                                }
                                if(logos[j].menu_logotipo_id == 11){
                                    this.show_veg = true;
                                }
                                if(logos[j].menu_logotipo_id == 20){
                                    this.show_vg = true;
                                }
                                if(logos[j].menu_logotipo_id == 21){
                                    this.show_dt = true;
                                }
                                if(logos[j].menu_logotipo_id == 23){
                                    this.show_lat = true;
                                }
                                if(logos[j].menu_logotipo_id == 22){
                                    this.show_ec = true;
                                }
                            }
                        }
                    }
                }
            }

            this.$vs.loading.close();
        },
        goBackToMenus() {
            let that = this;
            that.sidebar_active =  false;
            if(this.menus_translated.length === 0){
                this.getMenus(this.$route.params.hotelId);
            }
            this.$nextTick(function() {
                that.show_menu = false;
                let url = that.$route.path;
                if(process.env.VUE_APP_ROUTER_MODE === 'hash') {
                    url = '#' +url;
                }
                window.history.pushState('', '', url);
                if(!isNaN(that.$route.query.return)){
                    that.$router.replace({query: {id: that.$route.query.return}});
                }else{
                    that.$router.replace({query: null});
                }            
            });
        },
        order(id, name, description, price, currency, measure_id = null, measure) {
            this.current_order = {
                objectID: id,
                id: id,
                name: name,
                description: description,
                price: price,
                base_price: price,
                measure_id: measure_id,
                measure: measure,
                currency: this.currency,
                quantity: 1,
                hotel_id: this.hotel_id
            };

            this.$store.dispatch('eCommerce/additemInCart', this.current_order);

            this.$vs.notify({
                text: this.$t('added_item_to_cart'),
                color:'success',
                position:'bottom-right',
                iconPack: 'feather',
                icon:'icon-check'
            });
        },
        createPdf(){
            let that = this;
            this.$vs.loading();
            this.$api({
                method: 'get',
                url: '/myvilagale/cards/create-pdf',
                responseType: 'blob',
                params: {
                    token: this.$user.usertoken,
                    menu_id: this.selected_menu.menu_id,
                    lang: this.selected_menu.language,
                }
            }).then(function (res) {
                let content = res.data;
                let blob = new Blob([content], {type: 'application/pdf'});
                window.open(window.URL.createObjectURL(blob), '_blank');
            }).catch ( function (err) {
                that.notify("Erro", "red");
            }).then(function (res) {
                that.$vs.loading.close();
            });

        },
    },
    created() {
        let that = this;
        //this.$vs.loading();

        this.$api({
            method: 'get',
            url: '/myvilagale/hotel/getFiltroCartas',
            params: {
                token: process.env.VUE_APP_TOKEN,
                category_type: this.$route.meta.category_type
            }
        })
        .then((res) => {
            that.filtro_options = res.data;
        })
        .catch((err) => {
            that.$vs.notify({
                text: 'Ocorreu um erro.',
                color:'danger',
                position:'bottom-right',
                iconPack: 'feather',
                icon:'icon-alert-triangle'
            });
        }).then(() => {
            //that.$vs.loading.close();
        });

        if (typeof this.$route.params.lang !== 'undefined') {
            let lang = this.$route.params.lang;
            let all_langs = ['pt', 'br', 'en', 'fr', 'de', 'es'];
            if( lang == null || !all_langs.includes(lang)){
                lang = 'pt';
            }
            this.updateLocale(lang);
        }
        if (typeof this.$route.params.hotelId !== 'undefined') {
            this.idiomas = [];
            this.hotel_id = this.$route.params.hotelId;
            if(!isNaN(this.$route.query.id) && !this.show_menu) {
                this.seeMenu({menu_id: this.$route.query.id});
            }
            else {
                this.getMenus(this.$route.params.hotelId);
            }
        }else if (this.user !== null && this.user.hotel.hotel_id) {
            this.hotel_id = this.user.hotel.hotel_id;
            if(this.hotel_id !== this.$route.params.hotelId) {
                let params = this.$route.params;
                params.hotelId = this.hotel_id;
                this.$router.push({name: this.$route.name, params: params});
                return;
            }
            if(!isNaN(this.$route.query.id) && !this.show_menu) {
                this.seeMenu({menu_id: this.$route.query.id});
            }
            else {
                this.getMenus(this.$route.params.hotelId);
            }
        }
        if(this.hotel_id == '' || isNaN(this.hotel_id)) {
            this.$router.push({name: this.$route.name, params: {}});
            return;
        }
    },
    components: {
        HotelDropdown,
        VuePerfectScrollbar
    }
}
</script>

<style>
    .radios{
        display: flex;
    }
    @media only screen and (max-width: 600px) {
        .radios{
            display: block;
        }
    }
    @media only screen and (min-width: 600px) {
        .productItem {
            flex-wrap: initial !important;
        }
    }
    .logoIcon{
        width: 40px;
        height: 40px;
        background: rgb(195, 195, 195) none repeat scroll 0% 0%;
    }
    .side_bar_menu .vs-sidebar {
        position: fixed;
        z-index: 52000;
        width: 340px;
        max-width: 90vw;
    }
    .side_bar_menu .vs-sidebar .scroll-area {
        height: calc(100% - 5rem);
    }
    .side_bar_menu .vs-sidebar .vs-sidebar--items {
        overflow: auto;
    }
    .btn_side_bar {
        position: fixed;
        right: -2px;
        top: 0;
        bottom: 0;
        z-index: 9999;
        margin: auto auto;
    }
    .hotel_selection {
		margin-bottom: 25px;
	}
	.dropdown {
		margin-top: 25px;
	}

	.options_block {
		display: flex;
	}

	.element_button {
		margin-top: 19px;
		margin-left: 25px;
	}

    #full_page {
        display: block;
    }

    .logo-text{
        font-size: 26px;
        font-weight: 600;
        color: #4A4E4F;
        animation: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1) 0s normal forwards 1 fadein;
		font-family: 'Titillium Web',sans-serif;
    }

    .legendaLogo{    
        width: 25px;
        height: 25px;
    }
    .bg-white {
        background-color: #ffffff;
    }
    .desc-collapse .vs-collapse-item--header {
        padding: 4px 1rem 4px 1rem;
    }
</style>
